import { Card, ContentLoader, Box } from "@bca/ui-library";

const MobileLoaderCard = () => (
  <Box
    key="index"
    display="flex"
    justifyContent="center"
    width="100%"
    paddingX="0"
    paddingBottom="20px"
  >
    <Card
      css="display:flex; flex-direction: column"
      width="100%"
      height={691}
      paddingX={0}
      paddingY={0}
      marginY={0}
      marginX={0}
    >
      <ContentLoader width="100%" height={331}>
        <rect width="100%" height={331}></rect>
      </ContentLoader>
      <Box display="flex" justifyContent="center">
        <ContentLoader width="100%" height={300}>
          <rect width="35%" height={16} x={21} y={18} rx={4} ry={4}></rect>
          <rect width="35%" height={16} x="45%" y={18} rx={4} ry={4}></rect>
          <rect width="85%" height={16} x={21} y={60} rx={4} ry={4}></rect>
          <rect width="4%" height={16} x={21} y={101} rx={4} ry={4}></rect>
          <rect width="30%" height={16} x={"10%"} y={101} rx={4} ry={4}></rect>
          <rect width="4%" height={16} x="45%" y={101} rx={4} ry={4}></rect>
          <rect width="30%" height={16} x="51%" y={101} rx={4} ry={4}></rect>
          <rect width="4%" height={16} x={21} y={135} rx={4} ry={4}></rect>
          <rect width="30%" height={16} x={"10%"} y={135} rx={4} ry={4}></rect>
          <rect width="4%" height={16} x="45%" y={135} rx={4} ry={4}></rect>
          <rect width="30%" height={16} x="51%" y={135} rx={4} ry={4}></rect>
        </ContentLoader>
      </Box>
      <Box
        minWidth="335px"
        minHeight="165px"
        backgroundColor="rgba(190, 191, 190, 0.1)"
      ></Box>
    </Card>
  </Box>
);

export default MobileLoaderCard;
